import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Link } from 'react-router-dom';
export function Hero() {
  const [videoError, setVideoError] = useState(false);
  return <section className="relative h-[70vh] md:h-[80vh] w-full flex items-center justify-center overflow-hidden bg-[#0B1014]" data-id="element-521">
      {/* Background Video/Image */}
      <div className="absolute inset-0 z-0" data-id="element-522">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B1014]/70 via-transparent to-[#0B1014] z-10" data-id="element-523" />
        {!videoError ? <video autoPlay loop muted playsInline onError={() => setVideoError(true)} className="w-full h-full object-cover opacity-60" data-id="element-524">
            <source src="https://cdn.magicpatterns.com/uploads/2q3tacuBK8ZC44w1L9jBFo/1780592386907_original-6c3ae14a-0c9b-4523-b8db-ac481d27b84d (2).mp4" type="video/mp4" data-id="element-525" />
          </video> : <img src="https://cdn.magicpatterns.com/uploads/iyPetroGroUojZdyUQXNKw/SnapInsta.to_684225988_18095297486328170_7779366325725060661_n.jpg" alt="House of Flavors — Theatre of Dreams" className="w-full h-full object-cover opacity-60" data-id="element-526" />}
      </div>

      {/* Content */}
      <div className="relative z-20 text-center px-4 max-w-5xl mx-auto h-full flex flex-col items-center justify-center pt-6 md:pt-10" data-id="element-527">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mb-4 md:mb-6" data-id="element-528">
          <img src="https://cdn.magicpatterns.com/uploads/pkCge4WeKF7gnZEZgQvaMG/HOF-mail-logo-white.png" alt="House of Flavors" className="w-32 md:w-36 mx-auto mb-3 md:mb-1 opacity-80" data-id="element-529" />
          <h1 className="text-2xl md:text-[60px] text-white tracking-tight uppercase mb-2 md:mb-3 font-black leading-none" data-id="element-530">
            What brings you <br data-id="element-531" /> here today?
          </h1>
          <p className="text-xs md:text-[17px] text-gray-300 tracking-wide font-medium max-w-3xl mx-auto px-4 md:px-0" data-id="element-532">
            Select an experience to discover what House of Flavor has to offer.
          </p>
        </motion.div>
      </div>
    </section>;
}